import { render, staticRenderFns } from "./PrimaryTitle.vue?vue&type=template&id=397ee8fc&scoped=true"
import script from "./PrimaryTitle.vue?vue&type=script&lang=js"
export * from "./PrimaryTitle.vue?vue&type=script&lang=js"
import style0 from "./PrimaryTitle.vue?vue&type=style&index=0&id=397ee8fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397ee8fc",
  null
  
)

export default component.exports